import { useState, ReactNode } from 'react';
import { generateTheme } from '@/config/themes/base-theme';
import { BrandingContext } from './branding-context';
import { Theme } from '@mui/material/styles';
import { PartnerBrandingConfig } from '@/schemas/clientInitSchema';

export function BrandingProvider({ children }: { children: ReactNode }) {
  const [partnerBrandingConfig, setPartnerBrandingConfig] = useState<PartnerBrandingConfig>();
  const [isPartnerThemeLoading, setIsPartnerThemeLoading] = useState(true);
  const [partnerTheme, setPartnerTheme] = useState<Theme | undefined>();

  const setBranding = (config: PartnerBrandingConfig) => {
    setPartnerBrandingConfig(config);
    setPartnerTheme(generateTheme(config));
    setIsPartnerThemeLoading(false);
  };

  return (
    <BrandingContext.Provider
      value={{
        partnerBrandingConfig,
        setBranding,
        partnerTheme,
        isPartnerThemeLoading,
      }}
    >
      {children}
    </BrandingContext.Provider>
  );
}
